module.exports = __webpack_public_path__ + "static/media/Icon1.cd70f13a.webp";